import { GetExcelRequest, GetRequest, PutRequest } from "../../service"

const ControllerName = "BrokerPatient"

export const GetBrokerPatientsListGroups = (searchUrl) =>
    GetRequest(`${ControllerName}${searchUrl}`)

export const GetBrokerPatientsTemplate = () =>
    GetExcelRequest(`${ControllerName}/excel/broker-patients-template`)

export const GetBrokerStats = () =>
    GetRequest(`${ControllerName}/stats`)

export const ImportBrokerPatients = (formData) =>
    PutRequest(`${ControllerName}/excel/import-patients`, formData)